module.exports = __webpack_public_path__ + "img/box_active.1bfe6f8f.svg";